import { ColoursObj, ImageRenderer, Typography } from '@eventr/common-storybook'
import { Stack, Box } from '@mui/material'
import { EventrLogo } from '../../../assets/svgImages/Logo'
import { useRouteGuardContext } from '../../../state/routeGuardProvider'
import { navBarRef } from '../../../feat/layout/navBar'
import i18n from '../../../i18n/i18next'
import { useThemeContext } from '../../../state/themeState/themeContext'

export const NoItinerariesInstrunctionsTeam = () => {
    const { isAllowed } = useRouteGuardContext()
    const themeImages = useThemeContext((s) => s.themeImages)
    const navbarHeight = navBarRef.value?.current?.clientHeight ?? 0
    return (
        <>
            <Stack width={'100%'} padding={'0px 8px 10%'}>
                <EventrLogo />
            </Stack>

            <Box padding="16px" height={`calc(65vh - ${navbarHeight}px)`}>
                <Stack
                    width="100%"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                    gap="24px"
                    height={'100%'}
                >
                    <Typography
                        id="teamPageWelcomeTitle"
                        variant="mobileH3"
                        color={ColoursObj.core.primary}
                    >
                        {i18n.t('team.welcome-team-page')}
                    </Typography>
                    <ImageRenderer
                        variant="teamEmpty"
                        src={themeImages?.teamEmpty}
                    />

                    <Box textAlign={'center'}>
                        {isAllowed(['allowedEdit']) && (
                            <Typography
                                id="teamPageBetterSubText"
                                color={ColoursObj.core.secondary}
                                paddingTop="10px"
                                variant="bodyBold"
                            >
                                {i18n.t('team.better-with-team')}
                            </Typography>
                        )}
                        <Typography
                            variant="bodySubtext"
                            color={ColoursObj.shades.shade1}
                            align="center"
                        >
                            {isAllowed(['allowedEdit']) ? (
                                <Typography
                                    color={ColoursObj.core.primary}
                                    id="teamPageCreateNewItinerarySubText"
                                >
                                    {i18n.t('team.create-itinerary-home')}
                                </Typography>
                            ) : (
                                <Typography
                                    color={ColoursObj.core.primary}
                                    id="teamPageNoEditPermissionsSubText"
                                >
                                    {i18n.t('home.no-edit-permission')}
                                </Typography>
                            )}
                        </Typography>
                    </Box>
                </Stack>
            </Box>
        </>
    )
}
